import React, {PureComponent} from 'react';

import styles from './styles';

export default class TabNav extends PureComponent {

  render() {
    const {children, selected, onClick} = this.props;

    return (
      <div className={styles.tabNav} onClick={onClick}>
        {React.Children.map(children, child => React.cloneElement(child, {
          selected: selected === child.props.id
        }))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BarTab/TabNav.jsx